import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from "@mui/material";
import { Home, Print } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function SidebarContent(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Box sx={{ pt: 3, px: 2 }}> {/* 根据MUI规范调整顶部内边距 */}
      <List sx={{ 
        '& .MuiListItem-root': {
          borderRadius: 1, // 添加圆角效果
          marginBottom: 1, // 调整菜单项间距
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)', // 悬停效果
          }
        },
        '& .MuiListItemButton-root': {
          paddingY: 1.5, // 调整按钮垂直内边距
          paddingX: 2, // 调整按钮水平内边距
        }
      }}>
        <ListItem>
          <ListItemButton onClick={() => navigate("/addresses")}>
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Home />
            </ListItemIcon>
            <ListItemText primary="地址管理" />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton onClick={() => navigate("/print")}>
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Print />
            </ListItemIcon>
            <ListItemText primary="打印页面" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
}
